import * as React from 'react';
import classnames from 'classnames';
import { Flyout } from '@grandvisionhq/common';

const getCurrentItem = (options)=>{
    return options.find((option)=>option.url === '/'
    );
};
const createSubMenu = (options)=>{
    return options.filter((option)=>option.url !== '/'
    ).map((option)=>/*#__PURE__*/ React.createElement(Flyout.MenuItem, {
            key: option.label,
            link: option.url
        }, option.image ? /*#__PURE__*/ React.createElement("img", {
            src: option.image,
            alt: option.label,
            className: "country-switcher-menu__image"
        }) : option.label)
    );
};
const CountrySwitcherMenu = ({ options , className , tabIndex , ariaHidden =false ,  })=>{
    const currentItem = getCurrentItem(options);
    const subMenuItems = createSubMenu(options);
    if (!currentItem || subMenuItems.length === 0) {
        return null;
    }
    const triggerElement = currentItem.image ? /*#__PURE__*/ React.createElement("img", {
        className: "country-switcher-menu__image",
        src: currentItem.image,
        alt: currentItem.label
    }) : currentItem.label;
    return /*#__PURE__*/ React.createElement(Flyout, {
        "data-t": "country-switcher-menu",
        className: classnames('country-switcher-menu', className)
    }, /*#__PURE__*/ React.createElement(Flyout.Trigger, {
        className: "header-menu__icon country-switcher-menu__trigger",
        title: currentItem.label,
        tabIndex: tabIndex,
        "aria-hidden": ariaHidden
    }, triggerElement), /*#__PURE__*/ React.createElement(Flyout.Menu, {
        className: "country-switcher-menu__flyout-menu"
    }, subMenuItems));
};

export { CountrySwitcherMenu };
//# sourceMappingURL=CountrySwitcherMenu.js.map
